// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* QuillKit Styles */

/* Ensure nested lists are indented */
ul, ol {
  margin-left: 2em;
  padding-left: 2em;
}
ul ul, ul ol, ol ul, ol ol {
  margin-left: 2em;
  padding-left: 2em;
}

/* Custom counter styles for list formatting */
/* Define decimal-paren using @counter-style for browsers that support it */
@counter-style decimal-paren {
  system: numeric;
  symbols: '0' '1' '2' '3' '4' '5' '6' '7' '8' '9';
  suffix: ') ';
}

/* Fallback for browsers that don't support @counter-style (e.g., Safari, older Chrome) */
/* Use ::marker pseudo-element to render numbers with parentheses */
ol[style*="list-style-type: decimal-paren"] > li::marker,
ol.decimal-paren-style > li::marker {
  content: counter(list-item) ") ";
}

/* Main wrapper - using actual class name from JavaScript */
.quillkit-wrapper,
.quillkit-editor-wrapper {
  position: relative;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* Protect wrapper and its direct UI children from editor content formatting */
.quillkit-wrapper > *:not(.quillkit-editor-content):not(.quillkit-content),
.quillkit-editor-wrapper > *:not(.quillkit-editor-content):not(.quillkit-content) {
  font-size: 14px !important;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important;
}

/* Page View Styles */
.quillkit-editor-content.page-view-mode {
  background: #525659;
}

.quillkit-editor-preview.page-view-enabled {
  /* 8.5" x 11" paper at 96 DPI */
  width: 816px; /* 8.5 inches * 96 DPI */
  min-height: 1056px; /* 11 inches * 96 DPI */
  margin: 20px auto;
  padding: 96px; /* 1 inch margin on all sides */
  background: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  box-sizing: border-box;
}

/* Page Break Styles */
.quillkit-page-break {
  display: block;
  margin: 20px 0;
  padding: 10px 0;
  border-top: 2px dashed #007bff;
  border-bottom: 2px dashed #007bff;
  background: #f0f8ff;
  text-align: center;
  cursor: default;
  user-select: none;
  position: relative;
}

.quillkit-page-break-label {
  display: inline-block;
  background: #007bff;
  color: white;
  padding: 4px 12px;
  border-radius: 3px;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* In page view mode, page breaks create actual page separation */
.quillkit-editor-preview.page-view-enabled .quillkit-page-break {
  page-break-after: always;
  break-after: page;
  margin: 0 -96px; /* Extend to full page width */
  padding: 15px 96px;
  border: none;
  border-top: 3px solid #007bff;
  background: linear-gradient(to bottom, #007bff 0%, #007bff 3px, transparent 3px);
}

.quillkit-editor-preview.page-view-enabled .quillkit-page-break-label {
  background: #007bff;
  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.3);
}


.quillkit-editor-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 8px;
  background: #f5f5f5;
  border-bottom: 1px solid #ddd;
  border-radius: 4px 4px 0 0;
  flex-shrink: 0;
  font-size: 14px !important;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important;
}

/* Prevent all toolbar elements from inheriting editor text formatting */
.quillkit-editor-toolbar * {
  font-size: 14px !important;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important;
}

.quillkit-editor-toolbar-group {
  display: flex;
  gap: 4px;
  padding-right: 8px;
  border-right: 1px solid #ddd;
}

.quillkit-editor-toolbar-group:last-child {
  border-right: none;
}

.quillkit-editor-button {
  padding: 6px 10px;
  border: 1px solid #ccc;
  background: white;
  cursor: pointer;
  color: black;
  border-radius: 3px;
  font-size: 14px !important;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important;
  transition: all 0.2s;
}

/* Prevent text formatting in toolbar buttons from being affected by editor content styles */
/* But allow icon fonts to use their own font-family */
.quillkit-editor-button *:not([class*="fa-"]):not(i):not(svg) {
  font-size: 14px !important;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important;
}

/* Ensure Font Awesome icons can use their font - reset font-family to allow FA CSS variables to work */
.quillkit-editor-button i[class*="fa-"],
.quillkit-editor-button svg[class*="fa-"] {
  font-family: var(--_fa-family, "Font Awesome 7 Free") !important;
}

.quillkit-editor-button:hover {
  background: #e9e9e9;
  border-color: #999;
}

.quillkit-editor-button:active,
.quillkit-editor-button.active {
  background: #d0d0d0;
  border-color: #666;
}

.quillkit-editor-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Split button dropdown arrow - reduced padding to prevent overflow */
.quillkit-editor-split-arrow {
  padding: 6px 4px;
}

.quillkit-editor-select {
  padding: 6px 8px;
  border: 1px solid #ccc;
  background: white;
  border-radius: 3px;
  font-size: 14px !important;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important;
  cursor: pointer;
}

/* Prevent select elements from being affected by editor formatting */
.quillkit-editor-select * {
  font-size: 14px !important;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important;
}

.quillkit-editor-combobox-wrapper {
  position: relative;
  display: inline-block;
}

.quillkit-editor-combobox-input {
  padding: 6px 8px;
  border: 1px solid #ccc;
  background: white;
  border-radius: 3px;
  font-size: 14px !important;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important;
  width: 80px;
  box-sizing: border-box;
}

.quillkit-editor-combobox-input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.quillkit-editor-combobox-input::placeholder {
  color: #666;
  font-size: 13px !important;
}

/* Content area - using actual class name from JavaScript */
.quillkit-content,
.quillkit-editor-content {
  position: relative;
  overflow-y: auto;
  flex: 1 1 0;
  min-height: 0;
}

/* Textarea and preview - using actual class names from JavaScript */
.quillkit-textarea,
.quillkit-preview,
.quillkit-editor-textarea,
.quillkit-editor-preview {
  width: 100%;
  height: 100%;
  padding: 20px;
  border: none;
  font-family: 'Courier New', monospace;
  font-size: 14px;
  line-height: 1.5;
  resize: none;
  box-sizing: border-box;
}

.quillkit-editor-textarea:focus {
  outline: none;
}

/* Preview-specific styles - using actual class name from JavaScript */
.quillkit-preview,
.quillkit-editor-preview {
  border: none;
  background: white;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  /* Containment properties to prevent content from breaking out */
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  contain: layout style paint;
  /* Prevent long words from overflowing horizontally */
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.quillkit-editor-preview.html-mode {
  font-family: 'Courier New', monospace;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.quillkit-editor-preview.css-mode {
  font-family: 'Courier New', monospace;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.quillkit-mode-tabs {
  display: flex;
  gap: 4px;
  padding: 8px;
  background: #e9e9e9;
  color: black;
  border-bottom: 1px solid #ddd;
  flex-shrink: 0;
  font-size: 13px !important;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important;
}

/* Protect mode tabs from editor formatting */
.quillkit-mode-tabs * {
  font-size: 13px !important;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important;
}

.quillkit-mode-tab {
  padding: 6px 12px;
  border: 1px solid #ccc;
  background: white;
  color: black;
  cursor: pointer;
  border-radius: 3px;
  font-size: 13px;
  transition: all 0.2s;
}

.quillkit-mode-tab:hover {
  background: #f5f5f5;
  color: black;
}

.quillkit-mode-tab.active {
  background: #007bff;
  color: white;
  border-color: #007bff;
}

/* Math display styles */
.quillkit-editor-math {
  display: inline;
  /* Reduce padding to minimize space taken and prevent overlap */
  padding: 2px 4px;
  background: transparent;
  border-radius: 3px;
  font-family: inherit;
  cursor: default;
  /* Anchor math on the text baseline for proper alignment */
  vertical-align: baseline;
  /* Increase line height to provide more spacing between lines with fractions */
  line-height: 1.6;
}

.quillkit-editor-math-block {
  display: block;
  padding: 8px;
  margin: 8px 0;
  background: #f9f9f9;
  border-left: 3px solid #007bff;
  overflow-x: auto;
}

/* LaTeX/MathML preview */
.katex-display {
  margin: 1em 0;
  text-align: center;
}

/* MathML elements */
.quillkit-editor-mathml {
  display: inline-block;
  font-family: 'STIX Two Math', 'STIX Two Text', serif;
  cursor: default;
}

/*
 * MathML color attributes (mathcolor, mathbackground) are handled via JavaScript
 * in QuillKit.applyMathMLColors() because CSS attr() doesn't support color values.
 * The function converts MathML color attributes to inline styles dynamically.
 */

/* Dialog styles */
.quillkit-editor-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 20px;
  z-index: 1000;
  min-width: 300px;
  max-height: 80vh;
  overflow-y: auto;
}

.quillkit-editor-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.quillkit-editor-dialog-header {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
}

.quillkit-editor-dialog-body {
  margin-bottom: 15px;
}

.quillkit-editor-dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.quillkit-editor-dialog input,
.quillkit-editor-dialog textarea {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 3px;
  font-size: 14px;
  box-sizing: border-box;
}

.quillkit-editor-dialog label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

.quillkit-editor-dialog-label-spacing {
  margin-top: 10px;
}

/* Dialog styles (without -editor- prefix) */
.quillkit-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.quillkit-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  min-width: 400px;
  max-width: 600px;
}

.quillkit-dialog-header {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
}

.quillkit-dialog-body {
  margin-bottom: 15px;
}

.quillkit-dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.quillkit-dialog input,
.quillkit-dialog textarea {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 3px;
  font-size: 14px;
  box-sizing: border-box;
}

.quillkit-dialog label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

.quillkit-dialog-label-spacing {
  margin-top: 10px;
}

/* Custom Snippet Modal Styles */
.quillkit-editor-snippet-modal .quillkit-editor-dialog-body {
  max-height: 400px;
  overflow-y: auto;
}

.quillkit-editor-snippet-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.quillkit-editor-snippet-item {
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
}

.quillkit-editor-snippet-item:hover {
  border-color: #007bff;
  background-color: #f0f8ff;
}

.quillkit-editor-snippet-name {
  font-weight: bold;
  margin-bottom: 8px;
  color: #333;
}

.quillkit-editor-snippet-preview {
  padding: 8px;
  background-color: #f9f9f9;
  border: 1px solid #e0e0e0;
  border-radius: 3px;
  font-size: 12px;
  max-height: 100px;
  overflow: auto;
}

/* Table Styles */
/* Table wrapper for horizontal scrolling */
.quillkit-table-wrapper {
  overflow-x: auto;
  margin: 10px 0;
  position: relative;
}

.quillkit-editor-preview table {
  border-collapse: collapse;
  width: 100%;
  margin: 0;
  position: relative;
  table-layout: fixed;
}

.quillkit-editor-preview table td,
.quillkit-editor-preview table th {
  border: 1px solid #000000;
  padding: 8px;
  min-width: 50px;
  text-align: left;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
}

.quillkit-editor-preview table th {
  background-color: #f5f5f5;
  font-weight: bold;
}

/* Removed alternating row background to prevent last row appearing merged */

.quillkit-editor-preview table tr:hover {
  background-color: #f0f0f0;
}

/* Table resize handles */
.quillkit-table-resize-handle {
  position: absolute;
  z-index: 10;
}

.quillkit-table-resize-handle-col {
  top: 0;
  bottom: 0;
  width: 5px;
  right: -3px;
  cursor: col-resize;
}

.quillkit-table-resize-handle-row {
  left: 0;
  right: 0;
  height: 5px;
  bottom: -3px;
  cursor: row-resize;
}

.quillkit-table-resize-handle:hover {
  background-color: rgba(0, 123, 255, 0.3);
}

.quillkit-table-resizing {
  user-select: none;
  cursor: col-resize;
}

.quillkit-table-resizing-row {
  user-select: none;
  cursor: row-resize;
}

/* Image Resize Styles */
.quillkit-image-wrapper {
  display: inline-block;
  position: relative;
  max-width: 100%;
}

.quillkit-image-wrapper img {
  display: block;
  max-width: 100%;
  height: auto;
}

.quillkit-image-resize-handle {
  position: absolute;
  width: 8px;
  height: 8px;
  background-color: #007bff;
  border: 1px solid white;
  z-index: 10;
}

.quillkit-image-resize-handle-nw {
  top: -4px;
  left: -4px;
  cursor: nw-resize;
}

.quillkit-image-resize-handle-ne {
  top: -4px;
  right: -4px;
  cursor: ne-resize;
}

.quillkit-image-resize-handle-sw {
  bottom: -4px;
  left: -4px;
  cursor: sw-resize;
}

.quillkit-image-resize-handle-se {
  bottom: -4px;
  right: -4px;
  cursor: se-resize;
}

.quillkit-image-resize-handle:hover {
  background-color: #0056b3;
}

.quillkit-image-resizing {
  user-select: none;
  cursor: nwse-resize;
}

/* Drag and drop visual feedback */
.quillkit-drag-over {
  outline: 2px dashed #007bff;
  outline-offset: -2px;
  background-color: rgba(0, 123, 255, 0.05);
}

/* Icon Modal Styles */
.quillkit-editor-icon-modal {
  max-width: 600px;
  max-height: 80vh;
}

.quillkit-editor-icon-modal .quillkit-editor-dialog-body {
  max-height: 500px;
  overflow-y: auto;
}

.quillkit-editor-icon-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 15px;
  border-bottom: 2px solid #e0e0e0;
}

.quillkit-editor-icon-tab {
  padding: 8px 16px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 14px;
  color: #666;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  transition: all 0.2s;
}

.quillkit-editor-icon-tab:hover {
  color: #007bff;
}

.quillkit-editor-icon-tab.active {
  color: #007bff;
  border-bottom-color: #007bff;
  font-weight: bold;
}

.quillkit-editor-icon-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(60px, 1fr));
  gap: 10px;
  padding: 10px 0;
}

.quillkit-editor-icon-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 24px;
  min-height: 60px;
  position: relative;
}

.quillkit-editor-icon-item:hover {
  border-color: #007bff;
  background-color: #f0f8ff;
  transform: scale(1.05);
}

.quillkit-editor-icon-item i {
  font-size: 24px;
  display: block;
}

/* Icon label - shows when icon font is not loaded */
.quillkit-icon-label {
  font-size: 9px;
  color: #666;
  text-align: center;
  margin-top: 4px;
  line-height: 1.2;
  max-width: 100%;
  word-wrap: break-word;
  font-family: Arial, sans-serif;
}

/* Hide labels when icons are successfully loaded */
.quillkit-editor-icon-item.icons-loaded .quillkit-icon-label {
  display: none;
}

/* Make sure icon glyphs are visible */
.quillkit-editor-icon-item i.bi::before,
.quillkit-editor-icon-item i.fas::before,
.quillkit-editor-icon-item i.far::before,
.quillkit-editor-icon-item i.fab::before {
  font-family: inherit;
}

.quillkit-editor-icon-info {
  grid-column: 1 / -1;
  padding: 10px;
  background-color: #f9f9f9;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  margin-top: 10px;
}

.quillkit-editor-icon-info code {
  background-color: #e9ecef;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 11px;
  display: block;
  margin-top: 5px;
  word-break: break-all;
}

.quillkit-editor-icon-empty {
  grid-column: 1 / -1;
  text-align: center;
  padding: 40px;
  color: #999;
}

/*
 * Set base KaTeX font size to 13.5pt for all math elements
 * This ensures consistent sizing across all LaTeX content
 * Removed !important to allow inline font-size changes via toolbar
 */
.quillkit-editor-math {
  font-size: 13.5pt;
}

/*
 * Override KaTeX's default base font-size on .katex element
 * KaTeX sets font-size: 1em on .katex which can inherit from parent context
 * Default is 13.5pt but can be overridden via inline styles
 * Removed !important to allow inline font-size changes via toolbar
 */
.quillkit-editor-math .katex {
  font-size: 13.5pt;
}

/*
 * Allow KaTeX's natural relative sizing for proper math rendering.
 * Superscripts/subscripts render at 0.7em for clear distinction from base text.
 * The 13.5pt base font size ensures even small elements (0.7em = 9.45pt) are readable.
 */

/*
 * Ensure all base elements maintain the root font size
 * The .base class is the container for the main math expression line
 * Uses 1em to inherit from parent, allowing font-size changes to propagate
 */
.quillkit-editor-math .katex .base {
  font-size: 1em;
}

/*
 * Don't override sizing in fractions, square roots, and other structural elements
 * Let KaTeX handle the internal relative sizing naturally
 * The 13.5pt base is large enough that 0.7em portions are still readable
 */

/*
 * Don't override vlist elements - they need natural sizing for proper vertical positioning
 * vlist-t, vlist-r, vlist are used by KaTeX for stacking elements vertically
 */

/*
 * Don't override math element classes - let KaTeX handle sizing
 * These classes (mord, mop, etc.) represent different types of math atoms
 * and need to maintain their relative sizing for proper rendering
 */

/*
 * Don't override strut sizing - struts are invisible elements used for vertical positioning
 * They must maintain their calculated heights for proper alignment
 */

/*
 * Allow KaTeX elements to inherit font-family from parent ONLY when explicitly set
 * This enables font-family changes to apply to math elements while preserving
 * KaTeX's default mathematical fonts for proper symbol rendering
 *
 * We use the [style*="font-family"] selector to only force inheritance when
 * the parent math wrapper has an explicit inline font-family style applied
 * (which happens when user selects a font via the FontFamilyPlugin)
 */
.quillkit-editor-math[style*="font-family"] .katex,
.quillkit-editor-math[style*="font-family"] .katex *,
.quillkit-editor-mathml[style*="font-family"],
.quillkit-editor-mathml[style*="font-family"] * {
  font-family: inherit !important;
}

/* Column Layout Styles */
.quillkit-column-container {
  width: 100%;
  margin: 1em 0;
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.quillkit-column {
  flex: 1;
  min-height: 50px;
}

/* Ensure tables within columns stay contained */
.quillkit-column table {
  width: 100%;
  table-layout: fixed;
}

/* Prevent column breaks inside certain elements (legacy support) */
.quillkit-column-container h1,
.quillkit-column-container h2,
.quillkit-column-container h3,
.quillkit-column-container p,
.quillkit-column-container ul,
.quillkit-column-container ol,
.quillkit-column-container table,
.quillkit-column-container img {
  break-inside: avoid;
  -webkit-column-break-inside: avoid;
  page-break-inside: avoid;
}

/* NoteBox Widget Styles */
.quillkit-notebox-widget {
  display: block;
  margin: 15px 0;
  border: 2px solid #ffc107;
  border-radius: 6px;
  background-color: #fffbea;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.quillkit-notebox-header {
  background-color: #ffc107;
  color: #333;
  padding: 8px 12px;
  font-weight: bold;
  font-size: 14px;
  user-select: none;
}

.quillkit-notebox-content {
  padding: 12px;
  min-height: 40px;
  background-color: white;
  border-top: 1px solid #ffe69c;
  border-bottom: 1px solid #ffe69c;
}

.quillkit-notebox-content:focus {
  outline: 2px solid #ffc107;
  outline-offset: -2px;
}

.quillkit-notebox-footer {
  background-color: #fffbea;
  color: #666;
  padding: 6px 12px;
  font-size: 11px;
  font-style: italic;
  user-select: none;
  text-align: right;
}

/* DaisyUI-inspired styling for note box accordion */
.demme-note-box-accordion {
  border-radius: 1rem;
  margin-bottom: 1rem;
}

.bg-demme-orange-50 {
  background-color: #fff7ed;
}

.collapse {
  position: relative;
  display: grid;
  overflow: hidden;
  grid-template-rows: auto 0fr;
  transition: grid-template-rows 0.2s;
  border: 1px solid #fed7aa;
}

.collapse[open] {
  grid-template-rows: auto 1fr;
}

.collapse-plus > .collapse-title:after {
  content: "+";
  position: absolute;
  right: 1rem;
  font-size: 1.5rem;
}

.collapse[open].collapse-plus > .collapse-title:after {
  content: "−";
}

.collapse-title {
  cursor: pointer;
  padding: 1rem;
  font-weight: 500;
}

.text-demme-orange-700 {
  color: #c2410c;
}

.flex {
  display: flex;
}

.items-center {
  align-items: center;
}

.gap-2 {
  gap: 0.5rem;
}

.text-xl {
  font-size: 1.25rem;
}

.spa_content_wrapper {
  overflow: hidden;
}

.collapse-content {
  padding: 1rem;
}

.note-content {
  padding-bottom: 0;
}

.pb-0 {
  padding-bottom: 0;
}

.rounded-xl {
  border-radius: 1rem;
}

.mb-4 {
  margin-bottom: 1rem;
}

.font-normal {
  font-weight: 400;
}

/* Hide the default disclosure triangle/marker on details/summary elements */
details > summary::-webkit-details-marker {
  display: none;
}

details > summary::marker {
  display: none;
}

/* Additional rules specifically for note box accordions to ensure marker is hidden */
.demme-note-box-accordion > summary::-webkit-details-marker {
  display: none;
}

.demme-note-box-accordion > summary::marker {
  display: none;
}

.demme-note-box-accordion > summary {
  list-style: none;
  list-style-type: none;
}

/* For Firefox */
.demme-note-box-accordion > summary::-moz-list-bullet {
  list-style-type: none;
}

/* Ensure the summary doesn't show any marker by removing list styling */
.demme-note-box-accordion summary::before {
  display: none;
}

/* Bookmark Styles - Orange dashed lines matching backend */
.quillkit-bookmark,
.content-bookmark {
  display: block;
  margin: 20px 0;
  padding: 12px 16px;
  background: #fff7ed;
  border: 2px dashed #ff8c00;
  border-radius: 4px;
  cursor: default;
  user-select: none;
  position: relative;
  transition: all 0.2s;
}

.quillkit-bookmark:hover,
.content-bookmark:hover {
  background: #ffedd5;
  border-color: #ff7700;
}

.quillkit-bookmark-label {
  font-weight: bold;
  color: #ff8c00;
  font-size: 14px;
  margin-right: 10px;
}

.quillkit-bookmark-remove {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 3px;
  width: 24px;
  height: 24px;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  padding: 0;
  transition: all 0.2s;
}

.quillkit-bookmark-remove:hover {
  background: #c82333;
  transform: translateY(-50%) scale(1.1);
}

/* Bookmark Split Dialog Styles */
.quillkit-bookmark-split-dialog {
  min-width: 600px;
  max-width: 800px;
}

.quillkit-bookmark-split-info {
  padding: 15px;
  background: #f0f8ff;
  border: 1px solid #007bff;
  border-radius: 4px;
  margin-bottom: 20px;
}

.quillkit-bookmark-split-info p {
  margin: 5px 0;
  font-size: 14px;
}

.quillkit-bookmark-sections {
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-height: 400px;
  overflow-y: auto;
}

.quillkit-bookmark-section {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 15px;
  background: white;
}

.quillkit-bookmark-section-header {
  font-weight: bold;
  font-size: 16px;
  color: #007bff;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 2px solid #007bff;
}

.quillkit-bookmark-section-content {
  margin: 15px 0;
  padding: 15px;
  background: #f9f9f9;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  max-height: 200px;
  overflow-y: auto;
}

.quillkit-bookmark-section .quillkit-editor-button {
  margin-top: 10px;
}

/* H1 with blue background indicator */
h1[style*="background-color: blue"],
h1[style*="background-color: rgb(0, 0, 255)"],
h1[style*="background-color: #0000ff"],
h1[style*="background: blue"],
h1[style*="background: rgb(0, 0, 255)"],
h1[style*="background: #0000ff"] {
  position: relative;
}

h1[style*="background-color: blue"]::before,
h1[style*="background-color: rgb(0, 0, 255)"]::before,
h1[style*="background-color: #0000ff"]::before,
h1[style*="background: blue"]::before,
h1[style*="background: rgb(0, 0, 255)"]::before,
h1[style*="background: #0000ff"]::before {
  content: "📍";
  position: absolute;
  left: -25px;
  font-size: 16px;
}

/* List Indentation */
.quillkit-editor-preview ul,
.quillkit-editor-preview ol {
  padding-left: 0;
  margin-left: 40px;
  list-style-position: outside;
}

/* Nested List Indentation - Add indentation for nested lists */
.quillkit-editor-preview li > ul,
.quillkit-editor-preview li > ol {
  margin-left: 20px;
  list-style-position: outside;
}

/* Editable List Numbers */
.quillkit-editor-preview ol.quillkit-editable-numbers {
  list-style-type: none;
  counter-reset: item;
}

.quillkit-editor-preview ol.quillkit-editable-numbers > li {
  counter-increment: none;
  position: relative;
}

/* Hide the browser's default list marker to prevent duplicate numbers */
.quillkit-editor-preview ol.quillkit-editable-numbers > li::marker {
  content: none;
  display: none;
}

/* Prevent any pseudo-element markers from appearing */
.quillkit-editor-preview ol.quillkit-editable-numbers > li::before {
  content: none;
}

.quillkit-editable-list-number {
  display: inline-block;
  min-width: 1.5em;
  margin-right: 0.5em;
  color: inherit;
  font-weight: normal;
  cursor: text;
  outline: none;
  border: 1px solid transparent;
  border-radius: 2px;
  padding: 0 2px;
  transition: border-color 0.2s;
}

.quillkit-editable-list-number:hover {
  border-color: #ccc;
}

.quillkit-editable-list-number:focus {
  border-color: #007bff;
  background-color: #f0f8ff;
}

.quillkit-editable-list-number:empty::before {
  content: "1";
  color: #999;
}

/* API Key Modal Styles */
.quillkit-editor-api-key-overlay {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7) !important;
  z-index: 10000 !important;
}

.quillkit-editor-api-key-modal {
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  min-width: 400px;
  max-width: 600px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3) !important;
  z-index: 10001 !important;
}

.quillkit-editor-api-key-modal .quillkit-editor-dialog-header {
  background: #dc3545;
  color: white;
  padding: 15px 20px;
  margin: -20px -20px 15px -20px;
  border-radius: 4px 4px 0 0;
  font-size: 18px;
}

.quillkit-editor-api-key-modal .quillkit-editor-dialog-header i {
  margin-right: 8px;
}

.quillkit-editor-api-key-modal .quillkit-editor-dialog-footer {
  justify-content: center;
  padding-top: 15px;
  border-top: 1px solid #ddd;
  margin-top: 15px;
}

/* Table Context Menu Styles */
.quillkit-editor-context-menu {
  position: absolute;
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  z-index: 10000;
  min-width: 200px;
  padding: 4px 0;
  display: none;
}

.quillkit-editor-context-menu.show {
  display: block;
}

.quillkit-editor-context-menu-item {
  padding: 8px 16px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  display: flex;
  align-items: center;
  gap: 8px;
  user-select: none;
  background: white;
  border: none;
  width: 100%;
  text-align: left;
}

.quillkit-editor-context-menu-item:hover {
  background: #f0f0f0;
}

.quillkit-editor-context-menu-item:active {
  background: #e0e0e0;
}

.quillkit-editor-context-menu-separator {
  height: 1px;
  background: #ddd;
  margin: 4px 0;
}

.quillkit-editor-context-menu-label {
  flex: 1;
}

.quillkit-editor-context-menu-icon {
  width: 20px;
  text-align: center;
  font-weight: bold;
}

/* Circle Annotation Styles */
.quillkit-circle-annotation {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  margin: 0 4px;
  position: relative;
  vertical-align: middle;
}

/* Circle button that appears on selection */
.quillkit-circle-button {
  position: absolute;
  background: #007bff;
  color: white;
  border: 2px solid #0056b3;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  font-size: 16px;
  cursor: pointer;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.4);
  transition: all 0.2s;
}

.quillkit-circle-button:hover {
  background: #0056b3;
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.6);
}

.quillkit-circled-word {
  display: inline-block;
  padding: 4px 12px;
  border: 2px solid #ff6b35;
  border-radius: 20px; /* Oval shape instead of circle */
  min-width: 40px;
  text-align: center;
  font-weight: 500;
  color: #333;
  background: white;
}

.quillkit-annotation-above,
.quillkit-annotation-below {
  display: block;
  position: relative;
  font-size: 11px;
  color: #666;
  min-width: 50px;
  text-align: center;
  padding: 2px 4px;
}

.quillkit-annotation-input {
  display: inline-block;
  font-style: italic;
  outline: none;
  border: 1px dashed transparent;
  border-radius: 3px;
  transition: border-color 0.2s;
  min-width: 50px;
  padding: 2px 4px;
}

.quillkit-annotation-input:focus {
  border-color: #007bff;
  background: #f0f8ff;
}

.quillkit-annotation-input:empty:before {
  content: attr(data-placeholder);
  color: #ccc;
  font-style: italic;
}

.quillkit-annotation-input:not(:empty) {
  font-weight: 600;
  color: #007bff;
}

.quillkit-annotation-above {
  margin-bottom: 4px;
}

.quillkit-annotation-below {
  margin-top: 4px;
}

/* Dropdown for parts of speech */
.quillkit-annotation-dropdown {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  margin-top: 2px;
  min-width: 120px;
  max-height: 200px;
  overflow-y: auto;
}

.quillkit-annotation-option {
  padding: 6px 12px;
  cursor: pointer;
  font-size: 12px;
  font-style: normal;
  transition: background-color 0.2s;
}

.quillkit-annotation-option:hover {
  background-color: #f0f8ff;
  color: #007bff;
}

/* Delete button */
.quillkit-annotation-delete {
  position: absolute;
  top: -10px;
  right: -10px;
  background: #dc3545;
  color: white;
  border: 2px solid white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  opacity: 0;
  transition: opacity 0.2s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.quillkit-circle-annotation:hover .quillkit-annotation-delete {
  opacity: 1;
}

.quillkit-annotation-delete:hover {
  background: #c82333;
  transform: scale(1.1);
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB,qCAAqC;AACrC;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,8CAA8C;AAC9C,2EAA2E;AAC3E;EACE,eAAe;EACf,gDAAgD;EAChD,YAAY;AACd;;AAEA,yFAAyF;AACzF,mEAAmE;AACnE;;EAEE,gCAAgC;AAClC;;AAEA,2DAA2D;AAC3D;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,uGAAuG;EACvG,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA,8EAA8E;AAC9E;;EAEE,0BAA0B;EAC1B,kHAAkH;AACpH;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,YAAY,EAAE,wBAAwB;EACtC,kBAAkB,EAAE,uBAAuB;EAC3C,iBAAiB;EACjB,aAAa,EAAE,+BAA+B;EAC9C,iBAAiB;EACjB,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,8BAA8B;EAC9B,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,iEAAiE;AACjE;EACE,wBAAwB;EACxB,iBAAiB;EACjB,eAAe,EAAE,8BAA8B;EAC/C,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,gFAAgF;AAClF;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;;AAGA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,0BAA0B;EAC1B,cAAc;EACd,0BAA0B;EAC1B,kHAAkH;AACpH;;AAEA,wEAAwE;AACxE;EACE,0BAA0B;EAC1B,kHAAkH;AACpH;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,kHAAkH;EAClH,oBAAoB;AACtB;;AAEA,4FAA4F;AAC5F,sDAAsD;AACtD;EACE,0BAA0B;EAC1B,kHAAkH;AACpH;;AAEA,uGAAuG;AACvG;;EAEE,gEAAgE;AAClE;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,sEAAsE;AACtE;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,kHAAkH;EAClH,eAAe;AACjB;;AAEA,qEAAqE;AACrE;EACE,0BAA0B;EAC1B,kHAAkH;AACpH;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,kHAAkH;EAClH,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA,2DAA2D;AAC3D;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,aAAa;AACf;;AAEA,oEAAoE;AACpE;;;;EAIE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA,sEAAsE;AACtE;;EAEE,YAAY;EACZ,iBAAiB;EACjB,uGAAuG;EACvG,gEAAgE;EAChE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,qDAAqD;EACrD,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;EAC7B,cAAc;EACd,0BAA0B;EAC1B,kHAAkH;AACpH;;AAEA,6CAA6C;AAC7C;EACE,0BAA0B;EAC1B,kHAAkH;AACpH;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,+DAA+D;EAC/D,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,0DAA0D;EAC1D,wBAAwB;EACxB,8EAA8E;EAC9E,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;EACrB,oDAAoD;EACpD,eAAe;AACjB;;AAEA;;;;EAIE;;AAEF,kBAAkB;AAClB;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,iBAAiB;AACjB,2CAA2C;AAC3C;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,4EAA4E;;AAE5E;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,MAAM;EACN,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,WAAW;EACX,oCAAoC;EACpC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,oDAAoD;AACpD;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA,mDAAmD;AACnD;EACE,aAAa;AACf;;AAEA,sCAAsC;AACtC;;;;EAIE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;;;;EAIE;AACF;EACE,iBAAiB;AACnB;;AAEA;;;;;EAKE;AACF;EACE,iBAAiB;AACnB;;AAEA;;;;EAIE;;AAEF;;;;EAIE;AACF;EACE,cAAc;AAChB;;AAEA;;;;EAIE;;AAEF;;;EAGE;;AAEF;;;;EAIE;;AAEF;;;EAGE;;AAEF;;;;;;;;EAQE;AACF;;;;EAIE,+BAA+B;AACjC;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,mEAAmE;AACnE;;;;;;;;EAQE,mBAAmB;EACnB,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA,0BAA0B;AAC1B;EACE,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,oDAAoD;AACpD;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,4EAA4E;AAC5E;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,qFAAqF;AACrF;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;AACvB;;AAEA,wEAAwE;AACxE;EACE,aAAa;AACf;;AAEA,2DAA2D;AAC3D;;EAEE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;;;;;;EAME,kBAAkB;AACpB;;AAEA;;;;;;EAME,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA,qBAAqB;AACrB;;EAEE,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA,+DAA+D;AAC/D;;EAEE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA,0BAA0B;AAC1B;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,wEAAwE;AACxE;EACE,aAAa;EACb,aAAa;AACf;;AAEA,sDAAsD;AACtD;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,6BAA6B;EAC7B,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,oBAAoB;EACpB,2CAA2C;EAC3C,gBAAgB;EAChB,gBAAgB;EAChB,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;EAC5C,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB,EAAE,iCAAiC;EACtD,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,UAAU;EACV,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB","sourcesContent":["/* QuillKit Styles */\n\n/* Ensure nested lists are indented */\nul, ol {\n  margin-left: 2em;\n  padding-left: 2em;\n}\nul ul, ul ol, ol ul, ol ol {\n  margin-left: 2em;\n  padding-left: 2em;\n}\n\n/* Custom counter styles for list formatting */\n/* Define decimal-paren using @counter-style for browsers that support it */\n@counter-style decimal-paren {\n  system: numeric;\n  symbols: '0' '1' '2' '3' '4' '5' '6' '7' '8' '9';\n  suffix: ') ';\n}\n\n/* Fallback for browsers that don't support @counter-style (e.g., Safari, older Chrome) */\n/* Use ::marker pseudo-element to render numbers with parentheses */\nol[style*=\"list-style-type: decimal-paren\"] > li::marker,\nol.decimal-paren-style > li::marker {\n  content: counter(list-item) \") \";\n}\n\n/* Main wrapper - using actual class name from JavaScript */\n.quillkit-wrapper,\n.quillkit-editor-wrapper {\n  position: relative;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;\n  font-size: 14px;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n/* Protect wrapper and its direct UI children from editor content formatting */\n.quillkit-wrapper > *:not(.quillkit-editor-content):not(.quillkit-content),\n.quillkit-editor-wrapper > *:not(.quillkit-editor-content):not(.quillkit-content) {\n  font-size: 14px !important;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important;\n}\n\n/* Page View Styles */\n.quillkit-editor-content.page-view-mode {\n  background: #525659;\n}\n\n.quillkit-editor-preview.page-view-enabled {\n  /* 8.5\" x 11\" paper at 96 DPI */\n  width: 816px; /* 8.5 inches * 96 DPI */\n  min-height: 1056px; /* 11 inches * 96 DPI */\n  margin: 20px auto;\n  padding: 96px; /* 1 inch margin on all sides */\n  background: white;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);\n  box-sizing: border-box;\n}\n\n/* Page Break Styles */\n.quillkit-page-break {\n  display: block;\n  margin: 20px 0;\n  padding: 10px 0;\n  border-top: 2px dashed #007bff;\n  border-bottom: 2px dashed #007bff;\n  background: #f0f8ff;\n  text-align: center;\n  cursor: default;\n  user-select: none;\n  position: relative;\n}\n\n.quillkit-page-break-label {\n  display: inline-block;\n  background: #007bff;\n  color: white;\n  padding: 4px 12px;\n  border-radius: 3px;\n  font-size: 12px;\n  font-weight: bold;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* In page view mode, page breaks create actual page separation */\n.quillkit-editor-preview.page-view-enabled .quillkit-page-break {\n  page-break-after: always;\n  break-after: page;\n  margin: 0 -96px; /* Extend to full page width */\n  padding: 15px 96px;\n  border: none;\n  border-top: 3px solid #007bff;\n  background: linear-gradient(to bottom, #007bff 0%, #007bff 3px, transparent 3px);\n}\n\n.quillkit-editor-preview.page-view-enabled .quillkit-page-break-label {\n  background: #007bff;\n  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.3);\n}\n\n\n.quillkit-editor-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  padding: 8px;\n  background: #f5f5f5;\n  border-bottom: 1px solid #ddd;\n  border-radius: 4px 4px 0 0;\n  flex-shrink: 0;\n  font-size: 14px !important;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important;\n}\n\n/* Prevent all toolbar elements from inheriting editor text formatting */\n.quillkit-editor-toolbar * {\n  font-size: 14px !important;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important;\n}\n\n.quillkit-editor-toolbar-group {\n  display: flex;\n  gap: 4px;\n  padding-right: 8px;\n  border-right: 1px solid #ddd;\n}\n\n.quillkit-editor-toolbar-group:last-child {\n  border-right: none;\n}\n\n.quillkit-editor-button {\n  padding: 6px 10px;\n  border: 1px solid #ccc;\n  background: white;\n  cursor: pointer;\n  color: black;\n  border-radius: 3px;\n  font-size: 14px !important;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important;\n  transition: all 0.2s;\n}\n\n/* Prevent text formatting in toolbar buttons from being affected by editor content styles */\n/* But allow icon fonts to use their own font-family */\n.quillkit-editor-button *:not([class*=\"fa-\"]):not(i):not(svg) {\n  font-size: 14px !important;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important;\n}\n\n/* Ensure Font Awesome icons can use their font - reset font-family to allow FA CSS variables to work */\n.quillkit-editor-button i[class*=\"fa-\"],\n.quillkit-editor-button svg[class*=\"fa-\"] {\n  font-family: var(--_fa-family, \"Font Awesome 7 Free\") !important;\n}\n\n.quillkit-editor-button:hover {\n  background: #e9e9e9;\n  border-color: #999;\n}\n\n.quillkit-editor-button:active,\n.quillkit-editor-button.active {\n  background: #d0d0d0;\n  border-color: #666;\n}\n\n.quillkit-editor-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Split button dropdown arrow - reduced padding to prevent overflow */\n.quillkit-editor-split-arrow {\n  padding: 6px 4px;\n}\n\n.quillkit-editor-select {\n  padding: 6px 8px;\n  border: 1px solid #ccc;\n  background: white;\n  border-radius: 3px;\n  font-size: 14px !important;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important;\n  cursor: pointer;\n}\n\n/* Prevent select elements from being affected by editor formatting */\n.quillkit-editor-select * {\n  font-size: 14px !important;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important;\n}\n\n.quillkit-editor-combobox-wrapper {\n  position: relative;\n  display: inline-block;\n}\n\n.quillkit-editor-combobox-input {\n  padding: 6px 8px;\n  border: 1px solid #ccc;\n  background: white;\n  border-radius: 3px;\n  font-size: 14px !important;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important;\n  width: 80px;\n  box-sizing: border-box;\n}\n\n.quillkit-editor-combobox-input:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n.quillkit-editor-combobox-input::placeholder {\n  color: #666;\n  font-size: 13px !important;\n}\n\n/* Content area - using actual class name from JavaScript */\n.quillkit-content,\n.quillkit-editor-content {\n  position: relative;\n  overflow-y: auto;\n  flex: 1 1 0;\n  min-height: 0;\n}\n\n/* Textarea and preview - using actual class names from JavaScript */\n.quillkit-textarea,\n.quillkit-preview,\n.quillkit-editor-textarea,\n.quillkit-editor-preview {\n  width: 100%;\n  height: 100%;\n  padding: 20px;\n  border: none;\n  font-family: 'Courier New', monospace;\n  font-size: 14px;\n  line-height: 1.5;\n  resize: none;\n  box-sizing: border-box;\n}\n\n.quillkit-editor-textarea:focus {\n  outline: none;\n}\n\n/* Preview-specific styles - using actual class name from JavaScript */\n.quillkit-preview,\n.quillkit-editor-preview {\n  border: none;\n  background: white;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;\n  /* Containment properties to prevent content from breaking out */\n  position: relative;\n  overflow-y: auto;\n  overflow-x: hidden;\n  contain: layout style paint;\n  /* Prevent long words from overflowing horizontally */\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n}\n\n.quillkit-editor-preview.html-mode {\n  font-family: 'Courier New', monospace;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n\n.quillkit-editor-preview.css-mode {\n  font-family: 'Courier New', monospace;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n\n.quillkit-mode-tabs {\n  display: flex;\n  gap: 4px;\n  padding: 8px;\n  background: #e9e9e9;\n  color: black;\n  border-bottom: 1px solid #ddd;\n  flex-shrink: 0;\n  font-size: 13px !important;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important;\n}\n\n/* Protect mode tabs from editor formatting */\n.quillkit-mode-tabs * {\n  font-size: 13px !important;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important;\n}\n\n.quillkit-mode-tab {\n  padding: 6px 12px;\n  border: 1px solid #ccc;\n  background: white;\n  color: black;\n  cursor: pointer;\n  border-radius: 3px;\n  font-size: 13px;\n  transition: all 0.2s;\n}\n\n.quillkit-mode-tab:hover {\n  background: #f5f5f5;\n  color: black;\n}\n\n.quillkit-mode-tab.active {\n  background: #007bff;\n  color: white;\n  border-color: #007bff;\n}\n\n/* Math display styles */\n.quillkit-editor-math {\n  display: inline;\n  /* Reduce padding to minimize space taken and prevent overlap */\n  padding: 2px 4px;\n  background: transparent;\n  border-radius: 3px;\n  font-family: inherit;\n  cursor: default;\n  /* Anchor math on the text baseline for proper alignment */\n  vertical-align: baseline;\n  /* Increase line height to provide more spacing between lines with fractions */\n  line-height: 1.6;\n}\n\n.quillkit-editor-math-block {\n  display: block;\n  padding: 8px;\n  margin: 8px 0;\n  background: #f9f9f9;\n  border-left: 3px solid #007bff;\n  overflow-x: auto;\n}\n\n/* LaTeX/MathML preview */\n.katex-display {\n  margin: 1em 0;\n  text-align: center;\n}\n\n/* MathML elements */\n.quillkit-editor-mathml {\n  display: inline-block;\n  font-family: 'STIX Two Math', 'STIX Two Text', serif;\n  cursor: default;\n}\n\n/*\n * MathML color attributes (mathcolor, mathbackground) are handled via JavaScript\n * in QuillKit.applyMathMLColors() because CSS attr() doesn't support color values.\n * The function converts MathML color attributes to inline styles dynamically.\n */\n\n/* Dialog styles */\n.quillkit-editor-dialog {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: white;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  z-index: 1000;\n  min-width: 300px;\n  max-height: 80vh;\n  overflow-y: auto;\n}\n\n.quillkit-editor-dialog-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n}\n\n.quillkit-editor-dialog-header {\n  font-size: 18px;\n  font-weight: bold;\n  margin-bottom: 15px;\n}\n\n.quillkit-editor-dialog-body {\n  margin-bottom: 15px;\n}\n\n.quillkit-editor-dialog-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.quillkit-editor-dialog input,\n.quillkit-editor-dialog textarea {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  font-size: 14px;\n  box-sizing: border-box;\n}\n\n.quillkit-editor-dialog label {\n  display: block;\n  margin-bottom: 5px;\n  font-weight: bold;\n}\n\n.quillkit-editor-dialog-label-spacing {\n  margin-top: 10px;\n}\n\n/* Dialog styles (without -editor- prefix) */\n.quillkit-dialog-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n}\n\n.quillkit-dialog {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  min-width: 400px;\n  max-width: 600px;\n}\n\n.quillkit-dialog-header {\n  font-size: 18px;\n  font-weight: bold;\n  margin-bottom: 15px;\n}\n\n.quillkit-dialog-body {\n  margin-bottom: 15px;\n}\n\n.quillkit-dialog-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.quillkit-dialog input,\n.quillkit-dialog textarea {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  font-size: 14px;\n  box-sizing: border-box;\n}\n\n.quillkit-dialog label {\n  display: block;\n  margin-bottom: 5px;\n  font-weight: bold;\n}\n\n.quillkit-dialog-label-spacing {\n  margin-top: 10px;\n}\n\n/* Custom Snippet Modal Styles */\n.quillkit-editor-snippet-modal .quillkit-editor-dialog-body {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.quillkit-editor-snippet-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.quillkit-editor-snippet-item {\n  padding: 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.quillkit-editor-snippet-item:hover {\n  border-color: #007bff;\n  background-color: #f0f8ff;\n}\n\n.quillkit-editor-snippet-name {\n  font-weight: bold;\n  margin-bottom: 8px;\n  color: #333;\n}\n\n.quillkit-editor-snippet-preview {\n  padding: 8px;\n  background-color: #f9f9f9;\n  border: 1px solid #e0e0e0;\n  border-radius: 3px;\n  font-size: 12px;\n  max-height: 100px;\n  overflow: auto;\n}\n\n/* Table Styles */\n/* Table wrapper for horizontal scrolling */\n.quillkit-table-wrapper {\n  overflow-x: auto;\n  margin: 10px 0;\n  position: relative;\n}\n\n.quillkit-editor-preview table {\n  border-collapse: collapse;\n  width: 100%;\n  margin: 0;\n  position: relative;\n  table-layout: fixed;\n}\n\n.quillkit-editor-preview table td,\n.quillkit-editor-preview table th {\n  border: 1px solid #000000;\n  padding: 8px;\n  min-width: 50px;\n  text-align: left;\n  position: relative;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.quillkit-editor-preview table th {\n  background-color: #f5f5f5;\n  font-weight: bold;\n}\n\n/* Removed alternating row background to prevent last row appearing merged */\n\n.quillkit-editor-preview table tr:hover {\n  background-color: #f0f0f0;\n}\n\n/* Table resize handles */\n.quillkit-table-resize-handle {\n  position: absolute;\n  z-index: 10;\n}\n\n.quillkit-table-resize-handle-col {\n  top: 0;\n  bottom: 0;\n  width: 5px;\n  right: -3px;\n  cursor: col-resize;\n}\n\n.quillkit-table-resize-handle-row {\n  left: 0;\n  right: 0;\n  height: 5px;\n  bottom: -3px;\n  cursor: row-resize;\n}\n\n.quillkit-table-resize-handle:hover {\n  background-color: rgba(0, 123, 255, 0.3);\n}\n\n.quillkit-table-resizing {\n  user-select: none;\n  cursor: col-resize;\n}\n\n.quillkit-table-resizing-row {\n  user-select: none;\n  cursor: row-resize;\n}\n\n/* Image Resize Styles */\n.quillkit-image-wrapper {\n  display: inline-block;\n  position: relative;\n  max-width: 100%;\n}\n\n.quillkit-image-wrapper img {\n  display: block;\n  max-width: 100%;\n  height: auto;\n}\n\n.quillkit-image-resize-handle {\n  position: absolute;\n  width: 8px;\n  height: 8px;\n  background-color: #007bff;\n  border: 1px solid white;\n  z-index: 10;\n}\n\n.quillkit-image-resize-handle-nw {\n  top: -4px;\n  left: -4px;\n  cursor: nw-resize;\n}\n\n.quillkit-image-resize-handle-ne {\n  top: -4px;\n  right: -4px;\n  cursor: ne-resize;\n}\n\n.quillkit-image-resize-handle-sw {\n  bottom: -4px;\n  left: -4px;\n  cursor: sw-resize;\n}\n\n.quillkit-image-resize-handle-se {\n  bottom: -4px;\n  right: -4px;\n  cursor: se-resize;\n}\n\n.quillkit-image-resize-handle:hover {\n  background-color: #0056b3;\n}\n\n.quillkit-image-resizing {\n  user-select: none;\n  cursor: nwse-resize;\n}\n\n/* Drag and drop visual feedback */\n.quillkit-drag-over {\n  outline: 2px dashed #007bff;\n  outline-offset: -2px;\n  background-color: rgba(0, 123, 255, 0.05);\n}\n\n/* Icon Modal Styles */\n.quillkit-editor-icon-modal {\n  max-width: 600px;\n  max-height: 80vh;\n}\n\n.quillkit-editor-icon-modal .quillkit-editor-dialog-body {\n  max-height: 500px;\n  overflow-y: auto;\n}\n\n.quillkit-editor-icon-tabs {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 15px;\n  border-bottom: 2px solid #e0e0e0;\n}\n\n.quillkit-editor-icon-tab {\n  padding: 8px 16px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  font-size: 14px;\n  color: #666;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -2px;\n  transition: all 0.2s;\n}\n\n.quillkit-editor-icon-tab:hover {\n  color: #007bff;\n}\n\n.quillkit-editor-icon-tab.active {\n  color: #007bff;\n  border-bottom-color: #007bff;\n  font-weight: bold;\n}\n\n.quillkit-editor-icon-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(60px, 1fr));\n  gap: 10px;\n  padding: 10px 0;\n}\n\n.quillkit-editor-icon-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 15px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.2s;\n  font-size: 24px;\n  min-height: 60px;\n  position: relative;\n}\n\n.quillkit-editor-icon-item:hover {\n  border-color: #007bff;\n  background-color: #f0f8ff;\n  transform: scale(1.05);\n}\n\n.quillkit-editor-icon-item i {\n  font-size: 24px;\n  display: block;\n}\n\n/* Icon label - shows when icon font is not loaded */\n.quillkit-icon-label {\n  font-size: 9px;\n  color: #666;\n  text-align: center;\n  margin-top: 4px;\n  line-height: 1.2;\n  max-width: 100%;\n  word-wrap: break-word;\n  font-family: Arial, sans-serif;\n}\n\n/* Hide labels when icons are successfully loaded */\n.quillkit-editor-icon-item.icons-loaded .quillkit-icon-label {\n  display: none;\n}\n\n/* Make sure icon glyphs are visible */\n.quillkit-editor-icon-item i.bi::before,\n.quillkit-editor-icon-item i.fas::before,\n.quillkit-editor-icon-item i.far::before,\n.quillkit-editor-icon-item i.fab::before {\n  font-family: inherit;\n}\n\n.quillkit-editor-icon-info {\n  grid-column: 1 / -1;\n  padding: 10px;\n  background-color: #f9f9f9;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  margin-top: 10px;\n}\n\n.quillkit-editor-icon-info code {\n  background-color: #e9ecef;\n  padding: 2px 6px;\n  border-radius: 3px;\n  font-size: 11px;\n  display: block;\n  margin-top: 5px;\n  word-break: break-all;\n}\n\n.quillkit-editor-icon-empty {\n  grid-column: 1 / -1;\n  text-align: center;\n  padding: 40px;\n  color: #999;\n}\n\n/*\n * Set base KaTeX font size to 13.5pt for all math elements\n * This ensures consistent sizing across all LaTeX content\n * Removed !important to allow inline font-size changes via toolbar\n */\n.quillkit-editor-math {\n  font-size: 13.5pt;\n}\n\n/*\n * Override KaTeX's default base font-size on .katex element\n * KaTeX sets font-size: 1em on .katex which can inherit from parent context\n * Default is 13.5pt but can be overridden via inline styles\n * Removed !important to allow inline font-size changes via toolbar\n */\n.quillkit-editor-math .katex {\n  font-size: 13.5pt;\n}\n\n/*\n * Allow KaTeX's natural relative sizing for proper math rendering.\n * Superscripts/subscripts render at 0.7em for clear distinction from base text.\n * The 13.5pt base font size ensures even small elements (0.7em = 9.45pt) are readable.\n */\n\n/*\n * Ensure all base elements maintain the root font size\n * The .base class is the container for the main math expression line\n * Uses 1em to inherit from parent, allowing font-size changes to propagate\n */\n.quillkit-editor-math .katex .base {\n  font-size: 1em;\n}\n\n/*\n * Don't override sizing in fractions, square roots, and other structural elements\n * Let KaTeX handle the internal relative sizing naturally\n * The 13.5pt base is large enough that 0.7em portions are still readable\n */\n\n/*\n * Don't override vlist elements - they need natural sizing for proper vertical positioning\n * vlist-t, vlist-r, vlist are used by KaTeX for stacking elements vertically\n */\n\n/*\n * Don't override math element classes - let KaTeX handle sizing\n * These classes (mord, mop, etc.) represent different types of math atoms\n * and need to maintain their relative sizing for proper rendering\n */\n\n/*\n * Don't override strut sizing - struts are invisible elements used for vertical positioning\n * They must maintain their calculated heights for proper alignment\n */\n\n/*\n * Allow KaTeX elements to inherit font-family from parent ONLY when explicitly set\n * This enables font-family changes to apply to math elements while preserving\n * KaTeX's default mathematical fonts for proper symbol rendering\n *\n * We use the [style*=\"font-family\"] selector to only force inheritance when\n * the parent math wrapper has an explicit inline font-family style applied\n * (which happens when user selects a font via the FontFamilyPlugin)\n */\n.quillkit-editor-math[style*=\"font-family\"] .katex,\n.quillkit-editor-math[style*=\"font-family\"] .katex *,\n.quillkit-editor-mathml[style*=\"font-family\"],\n.quillkit-editor-mathml[style*=\"font-family\"] * {\n  font-family: inherit !important;\n}\n\n/* Column Layout Styles */\n.quillkit-column-container {\n  width: 100%;\n  margin: 1em 0;\n  display: flex;\n  gap: 20px;\n  align-items: flex-start;\n}\n\n.quillkit-column {\n  flex: 1;\n  min-height: 50px;\n}\n\n/* Ensure tables within columns stay contained */\n.quillkit-column table {\n  width: 100%;\n  table-layout: fixed;\n}\n\n/* Prevent column breaks inside certain elements (legacy support) */\n.quillkit-column-container h1,\n.quillkit-column-container h2,\n.quillkit-column-container h3,\n.quillkit-column-container p,\n.quillkit-column-container ul,\n.quillkit-column-container ol,\n.quillkit-column-container table,\n.quillkit-column-container img {\n  break-inside: avoid;\n  -webkit-column-break-inside: avoid;\n  page-break-inside: avoid;\n}\n\n/* NoteBox Widget Styles */\n.quillkit-notebox-widget {\n  display: block;\n  margin: 15px 0;\n  border: 2px solid #ffc107;\n  border-radius: 6px;\n  background-color: #fffbea;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.quillkit-notebox-header {\n  background-color: #ffc107;\n  color: #333;\n  padding: 8px 12px;\n  font-weight: bold;\n  font-size: 14px;\n  user-select: none;\n}\n\n.quillkit-notebox-content {\n  padding: 12px;\n  min-height: 40px;\n  background-color: white;\n  border-top: 1px solid #ffe69c;\n  border-bottom: 1px solid #ffe69c;\n}\n\n.quillkit-notebox-content:focus {\n  outline: 2px solid #ffc107;\n  outline-offset: -2px;\n}\n\n.quillkit-notebox-footer {\n  background-color: #fffbea;\n  color: #666;\n  padding: 6px 12px;\n  font-size: 11px;\n  font-style: italic;\n  user-select: none;\n  text-align: right;\n}\n\n/* DaisyUI-inspired styling for note box accordion */\n.demme-note-box-accordion {\n  border-radius: 1rem;\n  margin-bottom: 1rem;\n}\n\n.bg-demme-orange-50 {\n  background-color: #fff7ed;\n}\n\n.collapse {\n  position: relative;\n  display: grid;\n  overflow: hidden;\n  grid-template-rows: auto 0fr;\n  transition: grid-template-rows 0.2s;\n  border: 1px solid #fed7aa;\n}\n\n.collapse[open] {\n  grid-template-rows: auto 1fr;\n}\n\n.collapse-plus > .collapse-title:after {\n  content: \"+\";\n  position: absolute;\n  right: 1rem;\n  font-size: 1.5rem;\n}\n\n.collapse[open].collapse-plus > .collapse-title:after {\n  content: \"−\";\n}\n\n.collapse-title {\n  cursor: pointer;\n  padding: 1rem;\n  font-weight: 500;\n}\n\n.text-demme-orange-700 {\n  color: #c2410c;\n}\n\n.flex {\n  display: flex;\n}\n\n.items-center {\n  align-items: center;\n}\n\n.gap-2 {\n  gap: 0.5rem;\n}\n\n.text-xl {\n  font-size: 1.25rem;\n}\n\n.spa_content_wrapper {\n  overflow: hidden;\n}\n\n.collapse-content {\n  padding: 1rem;\n}\n\n.note-content {\n  padding-bottom: 0;\n}\n\n.pb-0 {\n  padding-bottom: 0;\n}\n\n.rounded-xl {\n  border-radius: 1rem;\n}\n\n.mb-4 {\n  margin-bottom: 1rem;\n}\n\n.font-normal {\n  font-weight: 400;\n}\n\n/* Hide the default disclosure triangle/marker on details/summary elements */\ndetails > summary::-webkit-details-marker {\n  display: none;\n}\n\ndetails > summary::marker {\n  display: none;\n}\n\n/* Additional rules specifically for note box accordions to ensure marker is hidden */\n.demme-note-box-accordion > summary::-webkit-details-marker {\n  display: none;\n}\n\n.demme-note-box-accordion > summary::marker {\n  display: none;\n}\n\n.demme-note-box-accordion > summary {\n  list-style: none;\n  list-style-type: none;\n}\n\n/* For Firefox */\n.demme-note-box-accordion > summary::-moz-list-bullet {\n  list-style-type: none;\n}\n\n/* Ensure the summary doesn't show any marker by removing list styling */\n.demme-note-box-accordion summary::before {\n  display: none;\n}\n\n/* Bookmark Styles - Orange dashed lines matching backend */\n.quillkit-bookmark,\n.content-bookmark {\n  display: block;\n  margin: 20px 0;\n  padding: 12px 16px;\n  background: #fff7ed;\n  border: 2px dashed #ff8c00;\n  border-radius: 4px;\n  cursor: default;\n  user-select: none;\n  position: relative;\n  transition: all 0.2s;\n}\n\n.quillkit-bookmark:hover,\n.content-bookmark:hover {\n  background: #ffedd5;\n  border-color: #ff7700;\n}\n\n.quillkit-bookmark-label {\n  font-weight: bold;\n  color: #ff8c00;\n  font-size: 14px;\n  margin-right: 10px;\n}\n\n.quillkit-bookmark-remove {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: #dc3545;\n  color: white;\n  border: none;\n  border-radius: 3px;\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n  font-size: 16px;\n  line-height: 1;\n  padding: 0;\n  transition: all 0.2s;\n}\n\n.quillkit-bookmark-remove:hover {\n  background: #c82333;\n  transform: translateY(-50%) scale(1.1);\n}\n\n/* Bookmark Split Dialog Styles */\n.quillkit-bookmark-split-dialog {\n  min-width: 600px;\n  max-width: 800px;\n}\n\n.quillkit-bookmark-split-info {\n  padding: 15px;\n  background: #f0f8ff;\n  border: 1px solid #007bff;\n  border-radius: 4px;\n  margin-bottom: 20px;\n}\n\n.quillkit-bookmark-split-info p {\n  margin: 5px 0;\n  font-size: 14px;\n}\n\n.quillkit-bookmark-sections {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.quillkit-bookmark-section {\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 15px;\n  background: white;\n}\n\n.quillkit-bookmark-section-header {\n  font-weight: bold;\n  font-size: 16px;\n  color: #007bff;\n  margin-bottom: 10px;\n  padding-bottom: 8px;\n  border-bottom: 2px solid #007bff;\n}\n\n.quillkit-bookmark-section-content {\n  margin: 15px 0;\n  padding: 15px;\n  background: #f9f9f9;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.quillkit-bookmark-section .quillkit-editor-button {\n  margin-top: 10px;\n}\n\n/* H1 with blue background indicator */\nh1[style*=\"background-color: blue\"],\nh1[style*=\"background-color: rgb(0, 0, 255)\"],\nh1[style*=\"background-color: #0000ff\"],\nh1[style*=\"background: blue\"],\nh1[style*=\"background: rgb(0, 0, 255)\"],\nh1[style*=\"background: #0000ff\"] {\n  position: relative;\n}\n\nh1[style*=\"background-color: blue\"]::before,\nh1[style*=\"background-color: rgb(0, 0, 255)\"]::before,\nh1[style*=\"background-color: #0000ff\"]::before,\nh1[style*=\"background: blue\"]::before,\nh1[style*=\"background: rgb(0, 0, 255)\"]::before,\nh1[style*=\"background: #0000ff\"]::before {\n  content: \"📍\";\n  position: absolute;\n  left: -25px;\n  font-size: 16px;\n}\n\n/* List Indentation */\n.quillkit-editor-preview ul,\n.quillkit-editor-preview ol {\n  padding-left: 0;\n  margin-left: 40px;\n  list-style-position: outside;\n}\n\n/* Nested List Indentation - Add indentation for nested lists */\n.quillkit-editor-preview li > ul,\n.quillkit-editor-preview li > ol {\n  margin-left: 20px;\n  list-style-position: outside;\n}\n\n/* Editable List Numbers */\n.quillkit-editor-preview ol.quillkit-editable-numbers {\n  list-style-type: none;\n  counter-reset: item;\n}\n\n.quillkit-editor-preview ol.quillkit-editable-numbers > li {\n  counter-increment: none;\n  position: relative;\n}\n\n/* Hide the browser's default list marker to prevent duplicate numbers */\n.quillkit-editor-preview ol.quillkit-editable-numbers > li::marker {\n  content: none;\n  display: none;\n}\n\n/* Prevent any pseudo-element markers from appearing */\n.quillkit-editor-preview ol.quillkit-editable-numbers > li::before {\n  content: none;\n}\n\n.quillkit-editable-list-number {\n  display: inline-block;\n  min-width: 1.5em;\n  margin-right: 0.5em;\n  color: inherit;\n  font-weight: normal;\n  cursor: text;\n  outline: none;\n  border: 1px solid transparent;\n  border-radius: 2px;\n  padding: 0 2px;\n  transition: border-color 0.2s;\n}\n\n.quillkit-editable-list-number:hover {\n  border-color: #ccc;\n}\n\n.quillkit-editable-list-number:focus {\n  border-color: #007bff;\n  background-color: #f0f8ff;\n}\n\n.quillkit-editable-list-number:empty::before {\n  content: \"1\";\n  color: #999;\n}\n\n/* API Key Modal Styles */\n.quillkit-editor-api-key-overlay {\n  position: absolute !important;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7) !important;\n  z-index: 10000 !important;\n}\n\n.quillkit-editor-api-key-modal {\n  position: absolute !important;\n  top: 50% !important;\n  left: 50% !important;\n  transform: translate(-50%, -50%) !important;\n  min-width: 400px;\n  max-width: 600px;\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3) !important;\n  z-index: 10001 !important;\n}\n\n.quillkit-editor-api-key-modal .quillkit-editor-dialog-header {\n  background: #dc3545;\n  color: white;\n  padding: 15px 20px;\n  margin: -20px -20px 15px -20px;\n  border-radius: 4px 4px 0 0;\n  font-size: 18px;\n}\n\n.quillkit-editor-api-key-modal .quillkit-editor-dialog-header i {\n  margin-right: 8px;\n}\n\n.quillkit-editor-api-key-modal .quillkit-editor-dialog-footer {\n  justify-content: center;\n  padding-top: 15px;\n  border-top: 1px solid #ddd;\n  margin-top: 15px;\n}\n\n/* Table Context Menu Styles */\n.quillkit-editor-context-menu {\n  position: absolute;\n  background: white;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n  z-index: 10000;\n  min-width: 200px;\n  padding: 4px 0;\n  display: none;\n}\n\n.quillkit-editor-context-menu.show {\n  display: block;\n}\n\n.quillkit-editor-context-menu-item {\n  padding: 8px 16px;\n  cursor: pointer;\n  font-size: 14px;\n  color: #333;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  user-select: none;\n  background: white;\n  border: none;\n  width: 100%;\n  text-align: left;\n}\n\n.quillkit-editor-context-menu-item:hover {\n  background: #f0f0f0;\n}\n\n.quillkit-editor-context-menu-item:active {\n  background: #e0e0e0;\n}\n\n.quillkit-editor-context-menu-separator {\n  height: 1px;\n  background: #ddd;\n  margin: 4px 0;\n}\n\n.quillkit-editor-context-menu-label {\n  flex: 1;\n}\n\n.quillkit-editor-context-menu-icon {\n  width: 20px;\n  text-align: center;\n  font-weight: bold;\n}\n\n/* Circle Annotation Styles */\n.quillkit-circle-annotation {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 0 4px;\n  position: relative;\n  vertical-align: middle;\n}\n\n/* Circle button that appears on selection */\n.quillkit-circle-button {\n  position: absolute;\n  background: #007bff;\n  color: white;\n  border: 2px solid #0056b3;\n  border-radius: 50%;\n  width: 30px;\n  height: 30px;\n  font-size: 16px;\n  cursor: pointer;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.4);\n  transition: all 0.2s;\n}\n\n.quillkit-circle-button:hover {\n  background: #0056b3;\n  transform: scale(1.1);\n  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.6);\n}\n\n.quillkit-circled-word {\n  display: inline-block;\n  padding: 4px 12px;\n  border: 2px solid #ff6b35;\n  border-radius: 20px; /* Oval shape instead of circle */\n  min-width: 40px;\n  text-align: center;\n  font-weight: 500;\n  color: #333;\n  background: white;\n}\n\n.quillkit-annotation-above,\n.quillkit-annotation-below {\n  display: block;\n  position: relative;\n  font-size: 11px;\n  color: #666;\n  min-width: 50px;\n  text-align: center;\n  padding: 2px 4px;\n}\n\n.quillkit-annotation-input {\n  display: inline-block;\n  font-style: italic;\n  outline: none;\n  border: 1px dashed transparent;\n  border-radius: 3px;\n  transition: border-color 0.2s;\n  min-width: 50px;\n  padding: 2px 4px;\n}\n\n.quillkit-annotation-input:focus {\n  border-color: #007bff;\n  background: #f0f8ff;\n}\n\n.quillkit-annotation-input:empty:before {\n  content: attr(data-placeholder);\n  color: #ccc;\n  font-style: italic;\n}\n\n.quillkit-annotation-input:not(:empty) {\n  font-weight: 600;\n  color: #007bff;\n}\n\n.quillkit-annotation-above {\n  margin-bottom: 4px;\n}\n\n.quillkit-annotation-below {\n  margin-top: 4px;\n}\n\n/* Dropdown for parts of speech */\n.quillkit-annotation-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  background: white;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n  margin-top: 2px;\n  min-width: 120px;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.quillkit-annotation-option {\n  padding: 6px 12px;\n  cursor: pointer;\n  font-size: 12px;\n  font-style: normal;\n  transition: background-color 0.2s;\n}\n\n.quillkit-annotation-option:hover {\n  background-color: #f0f8ff;\n  color: #007bff;\n}\n\n/* Delete button */\n.quillkit-annotation-delete {\n  position: absolute;\n  top: -10px;\n  right: -10px;\n  background: #dc3545;\n  color: white;\n  border: 2px solid white;\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  font-size: 14px;\n  line-height: 1;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  opacity: 0;\n  transition: opacity 0.2s;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.quillkit-circle-annotation:hover .quillkit-annotation-delete {\n  opacity: 1;\n}\n\n.quillkit-annotation-delete:hover {\n  background: #c82333;\n  transform: scale(1.1);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
